<script>
  import CabecalhoRelatorio from './CabecalhoRelatorio.vue';
  
  export default {
    components: { CabecalhoRelatorio },
    props: {
      dados: {
        type: Array,
        required: true,
      },
      projeto: {
        type: Object,
        required: true, 
      },
      titulo: {
        type: String,
        required: true,
      }
    }
  }
</script>

<template>
  <div>
    <cabecalho-relatorio :titulo="titulo" :nomeProjeto="projeto.nomeProjeto" borda=""></cabecalho-relatorio>
    
    <div class="table-responsive">
      <!--<table class="table table-condensed no-margins">
        <thead>
          <tr>
            <th>Projeto</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ projeto.nomeProjeto }}</td>
          </tr>
        </tbody>
      </table>-->
      
      <table class="table relatorio table-bordered table-hover table-striped">
        <thead>
          <tr>
            <th>Data</th>
            <th>CPF/CNPJ</th>
            <th>Rubrica</th>
            <th>Histórico</th>
            <th>Complemento</th>
            <th>Documento</th>
            <th>Valor&nbsp;(R$)</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="lancamento in dados">
            <td>{{ lancamento.data | formatarData }}</td>
            <td>{{ lancamento.cpfCnpj }}</td>
            <td>{{ lancamento.nomeRubrica || '---' }}</td>
            <td>{{ lancamento.historico }}</td>
            <td>{{ lancamento.complemento }}</td>
            <td>{{ lancamento.documento || '---' }}</td>
            <td :class="['text-right', lancamento.creditoDebito === 1 ? 'text-primary' : 'text-danger']">{{
              lancamento.valor | formatarNumero }}</td>
          </tr>
          <tr v-if="dados.length === 0">
            <td colspan="7" class="text-center">Não há dados.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/RelatorioLancamentosPagamentos.vue